import { useEffect, useState } from "react";

import Select from "../../components/Select";

import { useCampaign } from "../../context/campaign";
import { useNotification } from "../../context/notification";
import { apiRequest } from "../../utils/api";
import { getLocalValue } from "../../utils/auth";

import _ from "lodash";
import { useTranslation } from "react-i18next";
import styles from "./CampaignList.module.scss";

function CampaignList({
  variant = "standard",
  isCreateSession = false,
  isSessionScoped = false,
  country,
  ...props
}) {
  const { t } = useTranslation();
  const { addNotification } = useNotification();
  const {
    selectedCampaign,
    setSelectedCampaign,
    campaignList,
    setCampaignList,
    setIsAiCoachingEnabled,
  } = useCampaign();
  const [userCampaignList, setUserCampaignList] = useState([]);
  const [sessionCreationList, setSessionCreationList] = useState(null);

  useEffect(() => {
    if (isCreateSession) {
      getCampaign("", "createSession");
    } else {
      if (campaignList.length < 1 && !country) {
        getCampaign();
      } else if (country) {
        const api = "getRegionCampaignList";
        getCampaign(api);
      }
    }
  }, [country]);

  useEffect(() => {
    if (sessionCreationList) {
      let data = sessionCreationList.map(item => {
        return {
          value: item.campaign_id,
          label: item.sub_functional_unit,
          groupBy: item.functional_unit,
          ...item,
        };
      });

      setUserCampaignList(data);
    } else if (campaignList) {
      let data = campaignList.map(item => {
        return {
          value: item.campaign_id,
          label: item.sub_functional_unit,
          groupBy: item.functional_unit,
          ...item,
        };
      });
      setUserCampaignList(data);
    }
  }, [campaignList, sessionCreationList]);

  const getCampaign = (api, createSessionView) => {
    const createSession = isCreateSession ? `&view=session` : "";
    const apiUrl = api
      ? `/api/${api}?country_id=${country}`
      : `/api/getUserCampaignList?uid=${getLocalValue("uid")}${createSession}`;

    apiRequest
      .get(apiUrl)
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          // AI Coaching pilot region gate: invariant per coach (coaches only
          // work campaigns in their own home region), so set it regardless
          // of which list this response is for - except when a session is
          // already in scope on this page (isSessionScoped), where the
          // session's own fetch (by campaign region, not coach home region)
          // is the sole authority. Without this guard, both writes race the
          // same setIsAiCoachingEnabled and whichever settles last wins. See
          // alt-ai-coaching-pilot.md.
          if (!isSessionScoped) {
            setIsAiCoachingEnabled(Boolean(response.data.ai_coaching_enabled));
          }
          if (createSessionView) {
            setSessionCreationList(data);
          } else {
            if (!_.isEmpty(data)) {
              setCampaignList(data);
              if (country) {
                setSelectedCampaign(data[0].campaign_id);
              } else if (!selectedCampaign) {
                setSelectedCampaign(data[0].campaign_id);
              }
            }
          }
        } else if (response.status === 400) {
          addNotification(
            t(response.data.error, { property: response.data.property }),
            "error"
          );
        }
      })
      .catch(error => {
        addNotification(error, "error");
      });
  };

  return (
    <>
      {userCampaignList.length > 0 ? (
        <Select
          className={
            variant === "outlined"
              ? styles.dropdownSelect
              : styles.campaignSelection
          }
          searchable={true}
          variant={variant}
          groupBy={true}
          placeholder="Select a coach"
          list={userCampaignList}
          value={selectedCampaign}
          onChange={e => {
            if (localStorage.cerateSessionFormData) {
              const tmp = JSON.parse(localStorage.cerateSessionFormData);
              tmp.campaign_id = e.target.value;
              tmp.coachee_id = "";
              tmp.subjects = [];
              localStorage.setItem(
                "cerateSessionFormData",
                JSON.stringify(tmp)
              );
            }
            setSelectedCampaign(e.target.value);
          }}
        />
      ) : (
        <div>
          {" "}
          {`No functional unit tagged to ${getLocalValue("u_fullname")} `}
        </div>
      )}
    </>
  );
}

export default CampaignList;
